module.exports = __webpack_public_path__ + "img/5.113c32d0.jpg";